import { FAVORITE_STORED_SKILL_ROUTE, UNFAVORITE_STORED_SKILL_ROUTE } from '../../handlers/stored-skill-favorites';
import {
  LIST_STORED_SKILLS_ROUTE,
  GET_STORED_SKILL_ROUTE,
  CREATE_STORED_SKILL_ROUTE,
  UPDATE_STORED_SKILL_ROUTE,
  DELETE_STORED_SKILL_ROUTE,
  PUBLISH_STORED_SKILL_ROUTE,
} from '../../handlers/stored-skills';

export const STORED_SKILLS_ROUTES = [
  // Stored Skills CRUD Routes
  LIST_STORED_SKILLS_ROUTE,
  GET_STORED_SKILL_ROUTE,
  CREATE_STORED_SKILL_ROUTE,
  UPDATE_STORED_SKILL_ROUTE,
  DELETE_STORED_SKILL_ROUTE,
  // Publish
  PUBLISH_STORED_SKILL_ROUTE,
  // Favorites (EE)
  FAVORITE_STORED_SKILL_ROUTE,
  UNFAVORITE_STORED_SKILL_ROUTE,
] as const;
